<template>
    <div>
        <portal-target
            v-if="portalAvailable"
            name="product-return-create-step-1-header"
        />

        <h2 class="text-center">
            {{ __('Kérjük válassz ki egy rendelést!') }}
        </h2>

        <article v-for="order in orders"
                 class="profile-orders-order"
        >
            <div
                class="profile-orders-order-header my-padding-vertical-15 my-padding-horizontal-20 my-margin-bottom-20"
            >
                <div class="profile-orders-order-columns profile-orders-order-columns-center">
                    <div class="profile-orders-order-column my-column-one-half my-position-relative">
                        <div class="profile-orders-order-row">
                            <strong class="profile-orders-order-column-label">
                                {{ __('Rendelés azonosító') }}
                            </strong>:
                            <span class="profile-orders-order-column-value">
                                #{{ order.id }}
                            </span>
                        </div>
                        <div class="profile-orders-order-row">
                            <strong class="profile-orders-order-column-label">
                                {{ __('Rendelés leadva') }}
                            </strong>:
                            <span class="profile-orders-order-column-value">
                                {{ order.date }}
                            </span>
                        </div>
                        <div class="profile-orders-order-row">
                            <strong class="profile-orders-order-column-label">
                                {{ __('Végösszeg') }}
                            </strong>:
                            <span class="profile-orders-order-column-value">
                                {{ order.totalPrice }}
                            </span>
                        </div>
                    </div>

                    <div>
                        <button @click="selectOrder(order)">
                            {{ __('Kiválasztom') }}
                        </button>
                    </div>
                </div>
            </div>
        </article>
    </div>
</template>

<script>
export default {
    name: 'ProductReturnOrdersList',

    props: {
        orders: {
            type: Object|Array,
            required: true
        },
    },

    computed: {
        portalAvailable() {
            return 'PortalTarget' in this.$options.components
        },
    },

    methods: {
        selectOrder(order) {
            this.$emit('select-order', order)
        }
    },
}
</script>

<style lang="scss" scoped>
.profile-orders-order-columns-center {
    justify-content: space-between;
    align-items: center;
}
</style>
